/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

.web {
  display: flex;
  align-items: center;
  font-weight: var(--qds-control-standard-text);

  .tabs-item {
    --qds-control-tab-standard-title-line-height-emphasized: 20px;

    background: none;
    height: var(
      --qds-navigation-nav-item-height,
      var(--qds-control-tab-large-height)
    );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;

    &:focus-visible {
      outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
      border-radius: var(--qds-focus-border-radius);
      outline-offset: calc(
        -1 * var(--qds-focus-border-width) - var(--qds-focus-border-offset)
      );
    }
  }

  .tab {
    font-family: var(--qds-font-family-brand);
    font-size: var(--qds-control-tab-standard-title-emphasized);
    font-style: normal;
    font-weight: bold;
    line-height: var(--qds-control-tab-standard-title-line-height-emphasized);
    display: flex;
    align-items: center;
    height: 100%;
    white-space: nowrap;
    padding-inline: var(--qds-control-tab-large-padding-horizontal);
    padding-top: var(--qds-navigation-nav-item-padding-top, none);
    gap: var(--qds-control-tab-large-padding-horizontal);
  }

  qds-icon {
    transition-duration: 0.3s;
    transition-property: transform;
  }

  .is-open {
    transform: rotate(180deg);
  }

  .line {
    height: var(--qds-signature-line-connection-width);
    width: 100%;
    border-radius: var(--qds-signature-line-connection-cap-radius);
  }

  .tabs-item:hover .line {
    background: var(--qds-theme-signature-color-hover);
  }

  .pressed-line {
    background: var(--qds-theme-signature-color-pressed);
  }

  a {
    text-decoration: none;
    cursor: auto;
  }
}

.mobile {
  .mobile-item {
    background-color: var(--qds-theme-panel-subsection-standard-background);
    color: var(--qds-theme-text-standard);
    cursor: default;
    border-block-end: var(--qds-list-border-width) solid
      var(--qds-theme-divider-standard);
    min-height: var(--qds-list-item-large-height);
    padding: 0 var(--qds-list-item-large-padding-horizontal);

    &:focus-visible {
      outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
      outline-offset: -4px;
    }
  }

  .mobile-item:hover {
    background-color: var(--qds-theme-interactive-background-hover);
  }

  .mobile-item:active {
    background-color: var(--qds-theme-interactive-background-pressed);
  }

  a {
    cursor: default;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--qds-list-item-standard-gap-internal);
  }

  button {
    border: none;
    background-color: var(--qds-theme-panel-subsection-standard-background);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--qds-list-item-standard-gap-internal);
    width: 100%;
  }

  qds-icon {
    color: var(--qds-theme-text-standard);
    font-size: var(--qds-control-large-icon-size);
  }

  .qds-destination {
    transform: scaleX(var(--qds-direction-factor, 1));
  }

  .qds-mobile-title {
    font: var(--qds-list-item-large-title);
  }
}

li {
  list-style: none;
}

.hide {
  display: none;
}

.qds-icon {
  flex-shrink: 0;
  height: var(--qds-control-tab-standard-icon-size);
  width: var(--qds-control-tab-standard-icon-size);
}
